// Context is editable customer input, never an order or supplier record.
(() => {
  const clean = (value, limit = 250) => (value || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, limit);
  const syncContext = (container) => {
    const product = container.querySelector('[data-contact-product]')?.value.trim() || '';
    const variant = container.querySelector('[data-contact-variant]')?.value.trim() || '';
    const context = container.querySelector('[data-contact-context]');
    if (!context) return;
    container.querySelector('[data-contact-context-product]').textContent = product;
    container.querySelector('[data-contact-context-variant]').textContent = variant;
    context.hidden = !product && !variant;
  };
  const initialise = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-pet-contact-form]').forEach((container) => {
      const body = container.querySelector('[name="contact[body]"]');
      if (body && !body.value && params.has('message')) body.value = clean(params.get('message'), 2000);
      const values = {
        product: clean(params.get('product')),
        variant: clean(params.get('variant')),
        source: ['browse', 'product', 'cart'].includes(params.get('source')) ? params.get('source') : 'browse',
      };
      Object.entries(values).forEach(([key, value]) => {
        const input = container.querySelector(`[data-contact-${key}]`);
        if (input && !input.value) input.value = value;
      });
      syncContext(container);
    });
  };
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-contact-product], [data-contact-variant]')) return;
    const container = event.target.closest('[data-pet-contact-form]');
    if (container) syncContext(container);
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pet-contact-link][data-contact-variant-select]');
    if (!link) return;
    const select = document.getElementById(link.dataset.contactVariantSelect);
    const option = select?.selectedOptions[0];
    if (!option) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('variant', clean(option.dataset.contactVariantTitle));
    link.href = url.href;
  });
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
